import React, { useEffect, useState } from "react";
import _gif from "../assets/loader_gif.gif";
import loader_gif from "../assets/Loader (1).gif";
import altare2 from "../assets/Group 959.png";
import failImage from "../assets/illustration_device-error_270.png";
import { fetchQrEvents, fetchQrgenerator } from "../services/service";
import { useNavigate, useSearchParams } from "react-router-dom";
import Status from "./Status";
import DOMPurify from "dompurify";
import parse from "html-react-parser";

const HtmlContent = ({ data }) => {
  const sanitizeHtml = DOMPurify.sanitize(data);
  return <div className="response-text">{parse(sanitizeHtml)}</div>;
};
const Qrgeneration = () => {
  const [pageVisible, setPageVisible] = useState(false);
  const [status, setStatus] = useState(null);
  const [time, setTime] = useState("");
  const [encode, setEncode] = useState("");
  const [isBlured, setIsBlured] = useState(false);
  const [tppName, setTppName] = useState("");
  const [failWithUrl, setFailWithUrl] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);
  const [qrId, setQrId] = useState(null);
  const [clearVal, setClearVal] = useState(false);

  const navigate = useNavigate();
  const [searchParam] = useSearchParams();
  const [textData, setTextData] = useState({});

  useEffect(() => {
    const handleLoad = () => {
      setStatus(null);
      const client_id = searchParam.get("client_id");
      const request_uri = searchParam.get("request_uri");
      if (!client_id || !request_uri) {
        navigate("/error");
      } else {
        const request = {
          data: {
            redirectRequestParams: [],
            origin: "CONSUMER",
          },
        };
        searchParam.forEach((value, key) => {
          request.data.redirectRequestParams.push({
            name: key,
            value: value,
          });
        });
        fetchData(request);
      }
      window.history.replaceState({}, document.title, window.location.pathname);
    };
    window.addEventListener("load", handleLoad);
    return () => {
      window.removeEventListener("load", handleLoad);
    };

    // eslint-disable-next-line
  }, [navigate, searchParam]);

  const fetchData = async (requestObj) => {
    try {
      const response = await fetchQrgenerator(requestObj);
      if (response.status === 200) {
        setStatus(null);
        setClearVal(false);
        setQrId(response.data.data?.qrId);
        setEncode(response.data.data?.qrImage);
        setTime(response.data.data?.ttl);
        setPageVisible(true);
        setTextData(response.data.data.content);
        setTimeLeft(response.data.data?.ttl);
      } else if (response.status === 500) {
        navigate("/error");
        // 401 for same params value
      } else {
        navigate("/error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (time === null) return;

    const apiStartTime = Date.now();
    const interval = setInterval(() => {
      const currentTime = Date.now();
      const elapsedSeconds = Math.floor((currentTime - apiStartTime) / 1000);
      const newTime = Math.max(0, time - elapsedSeconds);
      setTimeLeft(newTime);
      setTime(newTime);
      if (timeLeft === 0) {
        if (status === null) {
          setStatus("expired");
        }
        setClearVal(true);
        clearInterval(interval);
      }
    }, 1000);

    const handleVisibility = () => {
      if (!document.hidden) {
        const currentTime = Date.now();
        const elapsedSeconds = Math.floor((currentTime - apiStartTime) / 1000);
        const newTime = Math.max(0, time - elapsedSeconds);
        setTimeLeft(newTime);
        setTime(newTime);
      }
    };
    document.addEventListener("visibilitychange", handleVisibility);
    return () => {
      clearInterval(interval);
      document.removeEventListener("visibilitychange", handleVisibility);
    };
    // eslint-disable-next-line
  }, [time]);

  useEffect(() => {
    const apiInterval = setInterval(() => {
      if (clearVal) {
        clearInterval(apiInterval);
        return;
      }
      fetchEvents(qrId);
    }, 10000);
    return () => clearInterval(apiInterval);
    // eslint-disable-next-line
  }, [qrId, clearVal]);

  const fetchEvents = async (qr) => {
    const response = await fetchQrEvents(qr);
    if (response.status === 200) {
      if (response.data.data?.qrStatus === "AUTHORIZED") {
        setStatus("success");
        setClearVal(true);
        setTime(0);
        if (
          response.data.data?.consent?.tppName !== undefined &&
          response.data.data?.consent?.tppName !== ""
        ) {
          setTppName(response.data.data.consent.tppName);
        }
        if (
          response.data.data?.consent?.tppRedirectionUrl !== undefined &&
          response.data.data?.consent?.tppRedirectionUrl !== ""
        ) {
          setTimeout(() => {
            window.location.href = response.data.data.consent.tppRedirectionUrl;
          }, 5000);
        }
      } else if (response.data.data?.qrStatus === "INPROGRESS") {
        setIsBlured(true);
        if (
          response.data.data?.consent?.tppName !== undefined &&
          response.data.data?.consent?.tppName !== ""
        ) {
          setTppName(response.data.data.consent.tppName);
        }
      } else if (response.data.data?.qrStatus === "FAILED") {
        setStatus("failed");
        setClearVal(true);
        if (
          response.data.data?.consent?.tppName !== undefined &&
          response.data.data?.consent?.tppName !== ""
        ) {
          setTppName(response.data.data.consent.tppName);
        }
        if (
          response.data.data?.consent?.tppRedirectionUrl !== undefined &&
          response.data.data?.consent?.tppRedirectionUrl !== ""
        ) {
          setStatus("success");
          setFailWithUrl(true);
          setTimeout(() => {
            window.location.href = response.data.data.consent.tppRedirectionUrl;
          }, 5000);
        }
      } else if (response.data.data?.qrStatus === "REJECTED") {
        setStatus("success");
        setClearVal(true);
        if (
          response.data.data?.consent?.tppName !== undefined &&
          response.data?.data?.consent?.tppName !== ""
        ) {
          setTppName(response.data.data.consent.tppName);
        }
        if (
          response.data.data?.consent?.tppRedirectionUrl !== undefined &&
          response.data.data?.consent?.tppRedirectionUrl !== ""
        ) {
          setTimeout(() => {
            window.location.href = response.data.data.consent.tppRedirectionUrl;
          }, 5000);
        }
      }
    } else {
      navigate("/error");
    }
  };

  const minutes = Math.floor(timeLeft / 60)
    .toString()
    .padStart(2, "0");
  const seconds = (timeLeft % 60).toString().padStart(2, "0");

  return (
    <div className="container">
      {pageVisible ? (
        <div>
          {status === null && (
            <div className="qr-page">
              <div className="text-container">
                <img
                  style={{ width: "50px" }}
                  src={textData.logoUrl}
                  alt="logo"
                />
                <div className="header-text">{textData.title}</div>
                <div className="text-content">
                  <div>{textData.description}</div>
                  <HtmlContent data={textData.workingSteps} />
                </div>
              </div>
              <div className="qr-container">
                <div className="qr-wrapper">
                  <img
                    src={`data:image/png;base64,${encode}`}
                    alt="qrimage"
                    style={{
                      width: "200px",
                      height: "200px",
                      filter: isBlured ? "blur(10px)" : "none",
                      opacity: isBlured ? "20%" : "",
                    }}
                  />
                  {isBlured && (
                    <div className="blur-text">
                      <div style={{ width: "150px", color: "#222325" }}>
                        Connection underway on your mobile device
                      </div>
                    </div>
                  )}
                </div>
                <div className="timer-wrapper">
                  <div className="time-content">
                    Time left to complete the connection
                  </div>
                  <div className="timer">
                    {minutes}:{seconds}
                  </div>
                </div>
              </div>
            </div>
          )}
          {status === "success" && (
            <div className="inner-container">
              <div className="container-success">
                <div className="container-logo">
                  <div className="image-loader">
                    <img
                      src={loader_gif}
                      alt="Gif"
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "10px",
                      }}
                    ></img>
                  </div>
                  <div className="inner-text">
                    {`You'll be redirected to ${tppName}. Don't close this window as we take you back.`}
                  </div>
                </div>
                <div className="footer-text2">
                  Powered by
                  <img
                    src={altare2}
                    alt="powered-logo"
                    style={{ width: "50px", height: "20px" }}
                  />
                </div>
              </div>
            </div>
            // <Status image={_gif} title={"You're all set!"} data={`You will be redirected to ${tppName} to continue.`} waitText={true} />
          )}
          {status === "expired" && (
            <Status
              image={failImage}
              title={"Your request has expired"}
              data={"If you want to connect, you can initiate a request again."}
              waitText={false}
            />
          )}
          {/* {status === "reject" &&
                        <Status image={_gif} title={'Request rejected on mobile'} data={`If you want to connect, you'll need to initiate a request again from ${tppName}.`} waitText={true} status={status} />
                    } */}
          {status === "failed" && (
            <Status
              image={failImage}
              title={"Your request has failed"}
              data={"If you want to connect, you can initiate a request again."}
              waitText={failWithUrl ? true : false}
            />
          )}
        </div>
      ) : (
        <div className="container-success">
          <div className="container-logo">
            <div className="logo" style={{ height: "250px" }}>
              <img
                src={_gif}
                alt="Gif"
                style={{
                  width: "140px",
                  height: "140px",
                  borderRadius: "10px",
                }}
              ></img>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Qrgeneration;
